import store from "../../store";
import NProgress from 'nprogress';
import {getCachedContinueUrl} from "@/services/continueService";


export default function ({next, to}) {
    // Mamy przesłany kontekst
    // I zapisywana jest do magazynu danych
    let continueUrl = to.query.continue || getCachedContinueUrl();

    if (store.state.context.app !== null || ! continueUrl) {
        return next();
    }


    let method = to.query.method;
    store.dispatch('setContextApplication', {continueUrl, method})
        .finally(() => {
            NProgress.inc();
            next();
        })
}
